import { css, cx, useTheme } from '@fable/theme'
import { FlexBox, Text } from '@fable/components'
import { useGenreStats } from './useGenreStats'

export const GenreStatsPieLabels = () => {
  const { colors } = useTheme()
  const stats = useGenreStats()

  return (
    <FlexBox
      className={cx(
        css`
          flex-shrink: 0;
          width: 134px;
          gap: 8px;
        `,
        'stats-genre-labels'
      )}
      alignItems="flex-end"
      flexDirection="column"
    >
      {stats.map((d) => (
        <FlexBox
          key={d.id}
          className={css`
            gap: 3px;
            width: 100%;
          `}
        >
          <FlexBox
            className={css`
              width: 100%;
            `}
            flexDirection="column"
            alignItems="flex-end"
          >
            <Text
              type="label"
              sizing="L"
              weight="500"
              color={colors.uiWhite}
              align="right"
            >
              {d.label}
            </Text>
            <Text
              className={css`
                opacity: 0.5;
              `}
              type="body"
              sizing="XS"
              weight="500"
              color={colors.uiWhite}
              align="right"
            >
              {d.value} {d.value === 1 ? 'book' : 'books'}
            </Text>
          </FlexBox>
          <span
            className={css`
              display: block;
              width: 12px;
              height: 12px;
              border-radius: 4px;
              background-color: ${d.color};
              transform: translateY(2px);
              flex-shrink: 0;
            `}
          />
        </FlexBox>
      ))}
    </FlexBox>
  )
}
